import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { TextArea } from "@/components/ui/input"

interface CommentTextAreaProps {
  isEditMode?: boolean
  fieldName: string
  maxLength?: number
  dataTestId?: string
}

const CommentTextArea = ({ isEditMode = true, fieldName, maxLength = 1000, dataTestId }: CommentTextAreaProps) => {
  const { t } = useTranslation()
  const { register, getValues } = useFormContext()

  return isEditMode ? (
    <TextArea
      {...register(fieldName)}
      className="h-16.5"
      label={t("common.comment")}
      maxLength={maxLength}
      data-testid={`${dataTestId}-comment-field`}
    />
  ) : (
    <div className="text-on-surface text-sm">{getValues(fieldName)}</div>
  )
}

export { CommentTextArea }
